'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./cart/cart'));
    processInclude(require('friartux/thirdParty/image-zoom'));
    processInclude(require('replica/components/aiTryOn'));
    processInclude(require('replica/components/feedback'));
});
